import { UserRetailAccount } from './types';

/** Live accounts first, then paper; within each group newest first. */
export const sortRetailAccountsLiveFirst = <T extends UserRetailAccount>(
  accounts: T[],
): T[] =>
  [...accounts].sort((a, b) => {
    if (a.isPaper !== b.isPaper) return a.isPaper ? 1 : -1;
    return new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime();
  });
